import pickUserStepUrl from './pick-user-step.html';

class PickUserStepCtrl {
  constructor(sdk) {
    'ngInject';

    Object.assign(this, { sdk });
  }

  $onInit() {
    const { location, position } = this.shift;
    this.filteredUserGroups = this.sdk('groupByLocationAndPosition')(
      this.users,
      location.id,
      position.id
    );
  }

  onFilter(filteredUsers) {
    const { location, position } = this.shift;
    this.filteredUserGroups = this.sdk('groupByLocationAndPosition')(
      filteredUsers,
      location.id,
      position.id
    );
  }

  onUserSelect(selectedUser) {
    this.selectedUser = selectedUser;
    this.onSelect({ user: selectedUser });
  }
}

export default {
  controller: PickUserStepCtrl,
  controllerAs: 'ctrl',
  bindings: {
    users: '<',
    shift: '<',
    onSelect: '&',
  },
  templateUrl: pickUserStepUrl,
};
